import React, { useCallback, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import '../Styles/Medyaf.css';
import reviews from '../data/reviews';

function LogoLoop() {
  const { t, i18n } = useTranslation();
  const viewportRef = useRef(null);

  const loopCards = useMemo(() => reviews, []);

  const scrollReviews = useCallback((direction) => {
    if (!viewportRef.current) return;

    const cardWidth = 360;
    const gap = 22;
    const scrollAmount = cardWidth + gap;
    viewportRef.current.scrollBy({
      left: direction === 'right' ? scrollAmount : -scrollAmount,
      behavior: 'smooth',
    });
  }, []);

  return (
    <div className="reviewsLoopSection">
      <h2
        className="reviewsLoopTitle"
        style={{ textAlign: i18n.language === 'ar' ? 'right' : 'left' }}
      >
        {t('mainMenu.customer_reviews')}
      </h2>

      <div className="reviewsLoopSlider">
        <button
          type="button"
          className="reviewsLoopArrow reviewsLoopArrowRight"
          onClick={() => scrollReviews('right')}
          aria-label="Next reviews"
        >
          &#8249;
        </button>

        <button
          type="button"
          className="reviewsLoopArrow reviewsLoopArrowLeft"
          onClick={() => scrollReviews('left')}
          aria-label="Previous reviews"
        >
          &#8250;
        </button>

        <div className="reviewsLoopViewport" ref={viewportRef}>
          <div className="reviewsLoopTrack">
          {loopCards.map((review, index) => (
            <div
              key={`${review.name}-${index}`}
              className="reviewsLoopCard"
            >
              <div className="reviewsLoopCardHeader">
                <div className="reviewsLoopAvatar" aria-hidden="true">
                  <img src="/users.png" alt="" className="reviewsLoopAvatarImage" />
                </div>
                <div className="reviewsLoopReviewer">
                  <h3>{review.name}</h3>
                 
                </div>
              </div>

              <p className="reviewsLoopComment">{review.comment}</p>

              <div className="reviewsLoopStars" aria-label={`${review.rating} stars`}>
                {Array.from({ length: review.rating }, (_, starIndex) => (
                  <span key={`${review.name}-star-${starIndex}`}>★</span>
                ))}
              </div>
            </div>
          ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default LogoLoop;